import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../components/DynamicForm";
import {
  newBackendUserFields,
  newBackendUserValidationSchema,
} from "../../../Schema/BackendUserSchema";
import { useAddBackendUser } from "../../../custom-hooks/queries";
import NotificationModal from "../../../components/NotificationModal";

const AddBackendUser = () => {
  // Auto-format phone number fields to 1-234-567-8900
  const formatPhoneInput = (e) => {
    let value = e.target.value.replace(/[^\d]/g, "");
    if (value.length > 11) value = value.slice(0, 11);
    let formatted = "";
    if (value.length > 0) {
      formatted += value[0];
    }
    if (value.length > 1) {
      formatted += "-" + value.slice(1, 4);
    }
    if (value.length > 4) {
      formatted += "-" + value.slice(4, 7);
    }
    if (value.length > 7) {
      formatted += "-" + value.slice(7, 11);
    }
    // Set the value using setRangeText for better cursor control
    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    input.value = formatted;
    // Try to keep the cursor at the end
    input.setSelectionRange(formatted.length, formatted.length);
  };
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const { mutate: addUser, isError } = useAddBackendUser();

  const onSubmit = (data) => {
    const userData = {
      email: data.email,
      first_name: data.firstName,
      middle_name: data.middleName,
      last_name: data.lastName,
      phone_number: data.phoneNumber,
      office_phone_number: data.officePhoneNumber,
      contact_preference: data.contactPreference,
      is_active: data.isActive,
      password: data.password,
      confirm_password: data.confirmPassword,
      user_permissions: {
        view__released_rfi: data.rights.includes("Providers Released RFI"),
        manage_rfi: data.rights.includes("Manage RFIs"),
        manage_provider: data.rights.includes("Manage Provider"),
        manage_sponsor: data.rights.includes("Manage Sponsor"),
        view_sponsor_activity: data.rights.includes("View Sponsor Activity"),
        view_provider_activity: data.rights.includes("View Provider Activity"),
        manage_backend_users: data.rights.includes("Manage User"),
        manage_standards: data.rights.includes("Standards"),
        manage_provider_rfi: data.rights.includes("Manage Provider RFIs"),
        request_assessment: data.rights.includes("Request Assessment"),
        auditor_management: data.rights.includes("Auditor Management"),
        view_assessment_calendar: data.rights.includes("Assessment Calendar"),
        view_assessment_logs: data.rights.includes("Assessment Logs"),
        receive_notifications: data.rights.includes("Receive Notifications"),
      },
    };

    addUser(userData, {
      onSuccess: () => {
        setMessage("User created successfully");
        setShow(true);
        setTimeout(() => navigate("/Backend/Users/BackendUsers"), 2000);
      },
      onError: (error) => {
        setMessage(error.response?.data?.message || "Failed to create user");
        setShow(true);
      },
    });
  };

  return (
    <>
      <DynamicForm
        formTitle="Add New Backend User"
        formDescription="Complete the information below to create a new Backend User."
        fields={newBackendUserFields}
        validationSchema={newBackendUserValidationSchema}
        onSubmit={onSubmit}
        defaultValues={{
          rights: [
            "Providers Released RFI",
            "Manage RFIs",
            "Manage Provider",
            "Manage Sponsor",
            "View Sponsor Activity",
            "View Provider Activity",
            "Manage User",
            "Standards",
            "Manage Provider RFIs",
            "Request Assessment",
            "Auditor Management",
            "Assessment Calendar",
            "Assessment Logs",
            "Receive Notifications",
          ],
        }}
        inputProps={{
          phoneNumber: {
            onInput: formatPhoneInput,
            maxLength: 14,
          },
          officePhoneNumber: {
            onInput: formatPhoneInput,
            maxLength: 14,
          },
        }}
      />
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={isError ? "Error" : "Success"}
        error={isError}
      />
    </>
  );
};

export default AddBackendUser;
